import React from "react";

const Header = () => {
  return <h1>Search</h1>;
};

export default Header;
